import {
  DictionaryEvidence,
  TableCells,
  TableColumn,
  TableFilterCells,
} from '@eas/common-web';
import { DictInsuranceCompany } from '@models';

export function useColumns(): TableColumn<DictInsuranceCompany>[] {
  const { dictionaryColumns } =
    DictionaryEvidence.useDictionaryColumns<DictInsuranceCompany>();

  return [
    {
      datakey: 'identifier',
      name: 'IČO',
      width: 150,
      CellComponent: TableCells.TextCell,
      FilterComponent: TableFilterCells.FilterTextCell,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    ...dictionaryColumns.map((c) => ({ ...c, filterGroup: 2 })),
  ];
}
